import { MessageCircle } from 'lucide-react'
import { BLOCK_BAR_CLASSES, HOLD_BAR_CLASSES } from '@/components/calendar/block-bars'
import { CleaningLegend } from '@/components/calendar/cleaning-bars'
import { DepositLegend, ReviewLegend, SupplyLegend } from '@/components/calendar/event-blocks'
import { GAP_BAR_CLASSES } from '@/components/calendar/gap-bars'
import { ChannelLegend, LegendSwatch } from '@/components/calendar/legend'
import type { CalendarLayerId } from '@/components/property/calendar/layers'

/**
 * What every colour, pattern and icon on the portfolio calendar means: the
 * property Calendar tab's own legend entries, in its order, for the layers
 * that are switched on (CAP-1417).
 *
 * Unlike the property tab, which lists only what its month holds, it lists
 * every look a layer can take: the grid scrolls through months, and a legend
 * that changed as it went would be one more thing moving.
 */
export function PortfolioLegend({ isVisible }: { isVisible: (id: CalendarLayerId) => boolean }) {
  return (
    <div
      data-testid="portfolio-legend"
      className="flex flex-wrap items-center gap-x-3 gap-y-1.5 text-xs text-textMuted"
    >
      {isVisible('stays') && (
        <>
          <ChannelLegend />
          <div className="flex items-center gap-1.5" data-testid="portfolio-legend-needs-reply">
            <MessageCircle className="h-3 w-3 text-amber" strokeWidth={2.5} aria-hidden="true" />
            <span>Needs reply</span>
          </div>
        </>
      )}
      {isVisible('blocks') && (
        <>
          <LegendSwatch className={BLOCK_BAR_CLASSES}>Owner block</LegendSwatch>
          <LegendSwatch className={HOLD_BAR_CLASSES}>Blocked in Uplisting</LegendSwatch>
        </>
      )}
      {isVisible('orphan_gaps') && (
        <LegendSwatch className={GAP_BAR_CLASSES}>Empty nights</LegendSwatch>
      )}
      {isVisible('deposits') && <DepositLegend />}
      {isVisible('supplies') && <SupplyLegend />}
      {isVisible('reviews') && <ReviewLegend />}
      {isVisible('cleaning') && <CleaningLegend />}
    </div>
  )
}
